<div class="image-viewer-container">
    <div class="image-viewer">
        @if (data.images) {
            <swiper-container
                #swiperRef
                (wheel)="onScroll($event)"
                initial-slide="{{data.viewIndex}}"
                loop="true"
                mousewheel="false"
                navigation="true"
                slidesPerView="1"
                zoom="true">
                @for (image of data.images; track image.id) {
                    <swiper-slide>
                        <div class="swiper-zoom-container image">
                            <img [src]="image.drawn_image ?? image.image ?? image"/>
                            <div class="info">
                                @if (image.image) {
                                    <div class="text">
                                        {{image.status.name}}<br>
                                        @if (image.updated_at) {
                                            {{image.updated_at | date : 'd MMM yyyy, H:mm'}}
                                        } @else {
                                            Zojuist gemaakt
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </swiper-slide>
                }
            </swiper-container>
        }
    </div>
</div>
<div class="controls-bottom">
    @if (showDrawing()) {
        <div (click)="drawOnImage($event)" class="fab big">
            <i class="fa-solid fa-pen-swirl"></i>
        </div>
    }
    <div class="fab big primary" (click)="dialogRef.close()">
        <i class="fas fa-times"></i>
    </div>
</div>
